<template>
	<div
		v-if="newVersionAvailable"
		class="alert alert-warning alert-dismissible fade show"
		role="alert">
		<strong>New version available!</strong> Please refresh the page to get the
		latest updates.
		<!-- <button
			type="button"
			class="btn-close"
			data-bs-dismiss="alert"
			aria-label="Close"></button> -->
	</div>
	<!-- Rest of your app -->
</template>

<script setup>
	import { ref, onMounted, onBeforeUnmount } from "vue"

	let timer = null
	const newVersionAvailable = ref(false)

	const checkForUpdates = async (skipDialog) => {
		try {
			//fetch the version file that is generated by a script
			const response = await fetch("/version.json")
			const data = await response.json()
			const newVersion = data.hash
			const version = localStorage.getItem("appVersion") || "1.0.0"
			if (newVersion !== version) {
				localStorage.setItem("appVersion", newVersion)
				if (!skipDialog) {
					newVersionAvailable.value = true
					if (timer) {
						//no longer need to check since there is a new version
						clearInterval(timer)
						timer = null
					}
				}
			}
		} catch (error) {
			console.error("Failed to check for updates:", error)
		}
	}

	onMounted(() => {
		// Check for updates immediately on mount
		checkForUpdates(true)

		//check once an hour
		timer = setInterval(() => checkForUpdates(false), 60 * 60 * 1000)
	})

	onBeforeUnmount(() => {
		if (timer) {
			clearInterval(timer)
			timer = null
		}
	})

	// onMounted(() => {
	//   const socket = new WebSocket('wss://your-cloudflare-worker-url');

	//   socket.onmessage = (event) => {
	//     const message = JSON.parse(event.data);
	//     if (message.type === 'version') {
	//       const newVersion = message.version;
	//       if (newVersion !== currentVersion.value) {
	//         newVersionAvailable.value = true;
	//         localStorage.setItem('appVersion', newVersion); // Store the new version in local storage
	//         socket.close(); // Disconnect the WebSocket
	//       }
	//     }
	//   };

	//   socket.onopen = () => {
	//     console.log('Connected to WebSocket server');
	//   };

	//   socket.onclose = () => {
	//     console.log('Disconnected from WebSocket server');
	//   };

	//   socket.onerror = (error) => {
	//     console.error('WebSocket error:', error);
	//   };
	// });
</script>

<style>
	.alert {
		position: fixed;
		top: 10px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 1050;
	}
</style>
